import { motion } from 'framer-motion';
import { Box, Gamepad2, Lock } from 'lucide-react';
import { useState } from 'react';
import { FadeIn } from '../components/AnimatedPanel';

type InventoryTab = 'models' | 'games';

export function InventoryPanel() {
  const [tab, setTab] = useState<InventoryTab>('models');

  const tabs: Array<{ id: InventoryTab; label: string; icon: typeof Box; upcoming?: boolean }> = [
    { id: 'models', label: 'Models', icon: Box, upcoming: true },
    { id: 'games', label: 'Games', icon: Gamepad2, upcoming: true },
  ];

  return (
    <div className="flex min-h-[480px] gap-6">
      <aside className="w-48 shrink-0 space-y-2">
        <FadeIn>
          <h2 className="mb-4 font-display text-2xl font-bold">Inventory</h2>
        </FadeIn>
        {tabs.map(({ id, label, icon: Icon, upcoming }) => (
          <button
            key={id}
            type="button"
            onClick={() => setTab(id)}
            className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm font-medium transition ${
              tab === id
                ? 'bg-gradient-to-r from-korvex-accent/20 to-korvex-violet/20 text-white'
                : 'text-korvex-muted hover:bg-white/5 hover:text-white'
            }`}
          >
            <Icon className="h-4 w-4" />
            {label}
            {upcoming && (
              <span className="ml-auto rounded-md bg-korvex-violet/20 px-1.5 py-0.5 text-[10px] uppercase text-korvex-violet">
                Soon
              </span>
            )}
          </button>
        ))}
      </aside>

      <motion.div
        key={tab}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.3 }}
        className="panel-card flex flex-1 flex-col items-center justify-center text-center"
      >
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/5">
          <Lock className="h-8 w-8 text-korvex-muted" />
        </div>
        <h3 className="font-display text-xl font-semibold">
          {tab === 'models' ? 'Your models' : 'Your games'}
        </h3>
        <p className="mt-2 max-w-sm text-sm text-korvex-muted">
          {tab === 'models'
            ? 'Upload and manage 3D models from Korvex Studio. This inventory view is coming in a future update.'
            : 'Published games you create will appear here. Games inventory is coming soon.'}
        </p>
        <span className="mt-6 rounded-full border border-korvex-accent/30 bg-korvex-accent/10 px-4 py-1.5 text-xs font-semibold text-korvex-accent">
          Upcoming feature
        </span>
      </motion.div>
    </div>
  );
}
